// extracted by mini-css-extract-plugin
export default {"container":"getInTouch_container__aQr28","container-lg":"getInTouch_container-lg__OPVJv","main":"getInTouch_main__2dfAj"};